




























































































































































































































































































































































































































































































































import Vue from "vue";

import store, { PartnerStore } from "../services/PartnerStore";
import cityStore, { CityStore } from "@/modules/city/services/CityStore";
import { ValidationRules } from "@/models/Validation";
import PartProdRelation, { PartProdRelationDefaultProps, PartProdRelationValidationRules as rules } from "../models/PartProdRelation";
import PartProdType from "../models/PartProdType";
import FormSection from "@/components/FormSection.vue";
import DateInput from "@/components/DateInput.vue";
import * as InvItemApi from "@/modules/invoiceItems/services/api";
import dayjs from "dayjs";


interface Data {
  store: PartnerStore;
  cityStore: CityStore;
  rules: ValidationRules;
  valid: boolean;
  oldRelation: PartProdRelation;
}

interface Methods {
  toggleEdit(): void;
  updateRelation(): void;
}

interface Computed {
  formattedBirthDate: string;
  taxName: string;
  isPrimaryProducer: boolean;
  selectableProdTypes: PartProdType[];
}

export default Vue.extend<Data, Methods, {}, Computed>({
  components: {
    FormSection,
    DateInput
  },

  async beforeMount() {
    this.store.taxes = await InvItemApi.getTaxes();
    await store.loadProdTypes();
    await store.loadPartProdRelation();
  },

  data() {
    return {
      store,
      cityStore,
      rules: rules,
      valid: false,
      oldRelation: {...PartProdRelationDefaultProps},
    };
  },

  methods: {
    toggleEdit() {
      if (!this.store.partProdRelation.inEdit) {
        this.oldRelation = {...this.store.partProdRelation};
        this.store.partProdRelation.inEdit = true;
      }
      else {
        this.store.partProdRelation = {...this.oldRelation, inEdit: false};
        this.store.partProdRelation.inEdit = false;
      }
    },
    async updateRelation() {
      await store.updatePartProdRelation();
      await store.loadPartProdRelation();
      await store.loadPartPersons(this.store.partner.id);
    },
  },

  computed: {
    formattedBirthDate() {
      return this.store.partProdRelation.birthDate ? dayjs(this.store.partProdRelation.birthDate).format('YYYY.MM.DD') : '-';
    },
    taxName() {
      return store.taxes.find(i => i.id === store.partProdRelation.taxId)?.name;
    },
    isPrimaryProducer() {
      return this.store.partProdRelation.prodType == 2;
    },
    selectableProdTypes() {
      return this.store.prodTypes.filter(i => i.id > 1);
    }
  },
});
